var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 3C0 1.343 1.343 0 3 0H13C14.657 0 16 1.343 16 3V13C16 14.657 14.657 16 13 16H3C1.343 16 0 14.657 0 13V3ZM4.85 13.393V6.169H2.434V13.393H4.85ZM3.642 5.182C4.484 5.182 5.009 4.628 5.009 3.934C4.993 3.225 4.484 2.686 3.658 2.686C2.831 2.686 2.291 3.225 2.291 3.934C2.291 4.628 2.815 5.182 3.626 5.182H3.642ZM8.604 13.393V9.359C8.604 9.143 8.62 8.928 8.683 8.773C8.858 8.342 9.256 7.895 9.923 7.895C10.798 7.895 11.148 8.557 11.148 9.529V13.393H13.564V9.251C13.564 7.032 12.372 5.999 10.782 5.999C9.5 5.999 8.925 6.699 8.604 7.192V6.169H6.187C6.219 6.844 6.188 13.352 6.187 13.394L8.604 13.393Z",
    fill: "#808080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.6a1958226b5ead508bb600cedb64d057.svg";
export { ForwardRef as ReactComponent };